<template>
  <div class="search-visitors" @click="toggleVisitorsPanel">
    <div class="search-input" :class="{'open': visitorsPanel?.visible}">
      <div class="search-input__label">{{$t('Travelers')}}</div>
      <div class="search-input__body">
        <span class="search-input__icon icon icon-users-group"></span>
        <span class="search-input__input">
          {{searchStore.getTotalVisitors}} traveler{{(searchStore.getTotalVisitors !== 1) ? 's' : ''}}
          {{searchStore.quantity}} room{{((searchStore as any).getTotalRooms !== 1) ? 's' : ''}}
        </span>
      </div>
    </div>
  </div>
  <Popover ref="visitorsPanel" @show="showVisitorsPanel" @hide="hideVisitorsPanel">
    <VisitorsSelector ref="visitorsSelector" @done="onVisitorsDone"/>
  </Popover>
</template>

<script setup lang="ts">
import Popover from "primevue/popover";
import VisitorsSelector from "~/components/VisitorsSelector.vue";
import { useSearchStore } from '~/store/search'
import dayjs from '~/utils/dayjs'

//searchStore
const searchStore = useSearchStore()

const visitorsPanel = ref();
const visitorsSelector = ref(null as any)
const isVisitorsPanelVisible = ref(false)


onMounted(async () => {
  const route = useRoute()
  const { quantity, adults, children, ages } = route.query
  if (quantity) {
    searchStore.setQuantity(+quantity)
  }

  if (adults) {
    searchStore.setAdults(+adults)
  }

  if (children && ages) {
    searchStore.setChildren(+children, (Array.isArray(ages) ? ages[0] : ages) as string)
  }
});

//methods
function showVisitorsPanel(event?: any) {
  isVisitorsPanelVisible.value = true
}

function hideVisitorsPanel(event?: any) {
  isVisitorsPanelVisible.value = false
}

function toggleVisitorsPanel(event: any) {
  if (isVisitorsPanelVisible.value && visitorsSelector.value) {
    const isValid = visitorsSelector?.value?.validate()
    if (!isValid) {
      return
    }
  }
  visitorsPanel.value.toggle(event);
  showVisitorsPanel()
}

function onVisitorsDone() {
  const isValid = visitorsSelector?.value?.validate()
  if (!isValid) {
    return
  }
  visitorsPanel.value.hide()
}

</script>

<style scoped lang="scss">
.search-visitors {
  min-width: 250px;

  //tablet
  @media (max-width: 1024px) {
    width: 100%;
  }

  .search-input__icon {
    margin-top: -5px;
  }
}
</style>
